import React from 'react';
import MikeNotificationItem from './MikeNotificationItem';
import styles from './Style/Notifications.module.scss';
import { nicelyFormatDate } from '../../../../generic/common';
import moment from 'moment';
import { INotifications } from './INotifications';
import { INotification } from './INotification';

interface IProps extends React.HTMLAttributes<HTMLElement> {
  /**
   * Notifications of one day.
   */
  notificationsPerDate?: INotifications;
  /**
   * href.
   */
  href?: string;
  /**
   * To add a placeholder for the first group.
   */
  isFirst: boolean;
  /**
   * Link callback.
   */
  onLinkCallBack?: (arg0: INotification) => void;
  /**
   * Custom render function.
   * To display the content of a notification item.
   */
  renderContent?: (notification: INotification) => {};
  /**
   * Custom render function.
   * To display the title of a notification item.
   */
  renderTitle?: (notification: INotification) => {};
}

/**
 * @name MikeNotificationItemGroup
 * @summary Shows the date of a list of notification items, as well as listing the notification items themselves.
 */
export const MikeNotificationItemGroup: React.FC<IProps> = ({
  notificationsPerDate,
  href,
  isFirst,
  onLinkCallBack,
  renderContent,
  renderTitle,
}: IProps) => {
  return (
    <div className={styles.notificationPerDayInnerContainer}>
      {!isFirst && <div className={styles.placeHolder} />}
      <div className={styles.notificationDate}>
        {notificationsPerDate &&
          nicelyFormatDate(moment(notificationsPerDate.date))}
      </div>
      <div className={styles.notification}>
        {notificationsPerDate &&
          notificationsPerDate.notifications.map(
            (notification: INotification, j) => (
              <MikeNotificationItem
                key={j}
                notification={notification}
                href={href}
                onLinkCallBack={onLinkCallBack}
                renderContent={renderContent}
                renderTitle={renderTitle}
              />
            )
          )}
      </div>
    </div>
  );
};

export default MikeNotificationItemGroup;
